import {
  type EmissionsReportSummaryOrFullT,
  type EmissionsReportT,
} from '@ruminati/types_v2/emissions-reports'
import { groupBy } from 'lodash-es'
import { defineStore } from 'pinia'
import { computed, ref, watch } from 'vue'
// import { reportResultsSeemsSuspicious } from '@/utilities/reports'

import { useOrganisationStore } from './organisations'

export const useEmissionsReportsStore = defineStore('emissionsReports', () => {
  const organisationStore = useOrganisationStore()

  const emissionsReports = ref<Array<EmissionsReportSummaryOrFullT>>([])

  function setEmissionsReports(reports: Array<EmissionsReportSummaryOrFullT>) {
    const existingReportsById = new Map(emissionsReports.value.map((report) => [report.id, report]))

    emissionsReports.value = reports.map((report) => {
      const existingReport = existingReportsById.get(report.id)
      if (existingReport && !existingReport.summary) {
        return existingReport
      }
      return report
    })
  }

  function addOrReplaceEmissionsReport(report: EmissionsReportSummaryOrFullT) {
    const existingIndex = emissionsReports.value.findIndex((r) => r.id === report.id)
    if (existingIndex > -1) {
      const existingReport = emissionsReports.value[existingIndex]
      if (existingReport && !existingReport.summary && report.summary) return
      emissionsReports.value.splice(existingIndex, 1, report)
    } else {
      emissionsReports.value.push(report)
    }
  }

  function removeEmissionsReport(emissionsReportId: string) {
    const idx = emissionsReports.value.findIndex((r) => r.id === emissionsReportId)
    if (idx > -1) emissionsReports.value.splice(idx, 1)
  }

  const fullEmissionsReports = computed<Array<EmissionsReportT>>(() =>
    emissionsReports.value.filter((r) => !r.summary),
  )

  const completedEmissionsReports = computed(() =>
    emissionsReports.value.filter((r) => r.completionDate),
  )

  const suspiciousEmissionsReports = computed(() => {
    // return completedEmissionsReports.value.filter(
    //   (r) => r.isGafReport && r.results && reportResultsSeemsSuspicious(r.results) !== false,
    // )
    return []
  })

  const completedEmissionsReportsWithExpectedResults = computed(() => {
    // return completedEmissionsReports.value.filter(
    //   (r) => r.isGafReport && r.results && reportResultsSeemsSuspicious(r.results) === false,
    // )
    return completedEmissionsReports.value
  })

  const emissionsReportsByPropertyId = computed(() => {
    return groupBy(emissionsReports.value, 'propertyId')
  })

  function resetEmissionsReports() {
    emissionsReports.value.length = 0
  }

  function resetAll() {
    emissionsReports.value.length = 0
  }

  watch(
    () => organisationStore.currentOrgId,
    () => {
      resetAll()
    },
  )

  return {
    emissionsReports,
    setEmissionsReports,
    addOrReplaceEmissionsReport,
    removeEmissionsReport,

    fullEmissionsReports,
    completedEmissionsReports,
    completedEmissionsReportsWithExpectedResults,
    suspiciousEmissionsReports,
    emissionsReportsByPropertyId,

    resetEmissionsReports,
    resetAll,
  }
})
